<template>
  <div class="site-logos">
    <span 
      v-for="(site, index) in sites"
      :key="index">
      <img 
        v-if="site in images" 
        :src="getImageURL(site)"
        style="width:100%;max-width:35px;margin-right:.5rem">
    </span>
  </div>
</template>

<script>
export default { 
  name: 'SiteLogos',
  props: {
    sites: {
      type: Array
    }
  },
  methods: {
    getImageURL (site) {
      if (site in this.images) {
        return this.images[site].url
      }
      return false
    }
  },
  computed: {
    images () {
      return this.$store.config.images
    }
  }
}
</script>
